import { IDR } from '@/libs/currency'
import {
  firstDateOfMonth, lastDateOfMonth, today,
  lastDateOfLastMonth,
  lastMonth,
  lastWeek,
} from '@/store/helpers'
import {
  LABELDAY, LABELMONTH, DAY_MONTH_YEAR,
} from '@/libs/filterDate'

export const dateRangeLocale = {
  format: 'dd/mm/yyyy',
  daysOfWeek: LABELDAY,
  monthNames: LABELMONTH,
}
export const dateRangeRanges = {
  'Semua Waktu': [new Date('2021-01-01'), today],
  'Bulan Ini': [firstDateOfMonth, lastDateOfMonth],
  'Bulan Lalu': [lastMonth(1), lastDateOfLastMonth],
  'Minggu Ini': lastWeek(0),
  'Minggu Lalu': lastWeek(1),
  'Custom Tanggal ': [today, today],
}

export const performaPartnerFields = [
  {
    key: 'partner_name',
    label: 'Nama Partner',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1 align-top',
    sortable: true,
  },
  {
    key: 'warehouse_name',
    label: 'Gudang',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1 align-top',
    sortable: true,
  },
  {
    key: 'total_orders',
    label: 'Total Order',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1 align-top',
    sortable: true,
  },
  {
    key: 'total_fulfillment',
    label: 'Nilai Fulfillment',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1 align-top',
    sortable: true,
    formatter: value => IDR(value).replace('.', ''),
  },
  {
    key: 'total_kompack_revenue',
    label: 'Revenue Kompack',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1 align-top',
    sortable: true,
    formatter: value => IDR(value).replace('.', ''),
  },
]

/**
 * Configuration for the tren request chart
 *
 * note: Request QC Color is #34A770 in case the Request QC is added back
 *
 * @type {Object}
 */
export const trenRequestOptionsChart = {
  chart: {
    height: '400px',
    type: 'area',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '10px',
    color: '#626262',
    stacked: false,
    toolbar: { show: false },
    zoom: { enabled: true },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
    fontWeight: 500,
    itemMargin: {
      vertical: 10,
    },
  },
  colors: ['#FBA63C', '#08A0F7', '#E31A1A'],
  fill: {
    type: 'gradient',
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.5,
      opacityTo: 0.9,
      stops: [0, 90, 100],
    },
  },
  tooltip: {
    x: {
      formatter(value) {
        return DAY_MONTH_YEAR(value)
      },
    },
  },
}
